<template>
  <div class="AfterOrderSelect-container">
    <el-select
      v-model="value"
      ref="select"
      placeholder="请选择售后单，可输入关键字搜索"
      filterable
      prefix-icon="el-icon-search"
      :filter-method="searchOrder"
      :disabled="disabled"
      :style="tcfstyle"
      @clear="clearSelect">
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          :row-style="{cursor: 'pointer'}"
          @row-click="openDetails"
          style="width: 100%">
          <el-table-column
            label="订单号"
            width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#99a9bf">订单号：</span>
              <span> {{scope.row.order_num}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="生产单号"
            width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#99a9bf">原正单：</span>
              <span>{{scope.row.before_num}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="经销商"
            width="120"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span><i class="el-icon-user"></i> {{scope.row.all_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="详细地址"
            min-width="160"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span><i class="el-icon-location-outline"></i>  {{scope.row.address}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="订单时间"-->
<!--            width="170"-->
<!--            show-overflow-tooltip>-->
<!--            <template slot-scope="scope">-->
<!--              <span><i class="el-icon-time"></i> {{scope.row.time}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-select>
  </div>
</template>
<script>
import { getAfterSaleOrder } from '@/api/erp'
import { getUser } from '@/utils/auth'

export default {
  name: 'AfterOrderSelect',
  computed: {
    user: getUser
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    oldorderid: {
      type: String
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      value: '',
      changeLabel: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      let oldorderid = ''
      if (this.oldorderid !== null && this.oldorderid !== '' && this.oldorderid !== undefined) {
        oldorderid = this.oldorderid
      }
      const data = {
        content: this.filterText,
        page: this.currentPage,
        limit: this.pageSize,
        oldorderid: oldorderid,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role
      }
      getAfterSaleOrder(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
        if (this.oldorderid !== null && this.oldorderid !== '' && this.oldorderid !== undefined) {
          this.changeLabel = response.msg
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = ''
      this.changeLabel = ''
      this.$emit('input', this.value)
    },
    searchOrder(val) {
      this.filterText = val
      this.getData()
    },
    openDetails(data) {
      this.value = data.order_id
      this.changeLabel = data.order_num + ' / ' + data.before_num + ' / ' + data.address
      this.$emit('input', this.value)
      this.$emit('setOrder', data)
      this.$refs.select.blur()
    }
  }
}
</script>
<style lang="scss" scoped>
.AfterOrderSelect-container{
  .el-table::before{
    height: 0!important;
  }
  .el-pagination{
    margin-top: 20px;
  }
}
</style>
